(() => {
  class QuickOrder {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId || '';
      this.searchLimit = Number(root.dataset.searchLimit || 8);
      this.showBarcode = root.dataset.showBarcode === 'true';
      this.showSku = root.dataset.showSku === 'true';
      this.showImages = root.dataset.showImages === 'true';

      this.searchInput = root.querySelector('[data-search-input]');
      this.suggestionsEl = root.querySelector('[data-suggestions]');
      this.resultsBody = root.querySelector('[data-results-body]');
      this.messageEl = root.querySelector('[data-message]');
      this.loadingEl = root.querySelector('[data-loading]');
      this.summaryEl = root.querySelector('[data-summary]');
      this.bulkReportEl = root.querySelector('[data-bulk-report]');
      this.bulkTextarea = root.querySelector('[data-bulk-textarea]');
this.csvInput = root.querySelector('[data-csv-input]');


      this.lines = new Map();
      this.productCache = new Map();
      this.suggestions = [];
      this.activeSuggestionIndex = -1;
      this.searchDebounce = null;
      this.toastTimeout = null;
      this.toastEl = this.createToast();

      this.bindEvents();
      this.render();
    }

    bindEvents() {
      if (this.searchInput) {
        this.searchInput.addEventListener('input', () => {
          const query = this.searchInput.value.trim();

          clearTimeout(this.searchDebounce);
          this.searchDebounce = setTimeout(() => {
            this.loadSuggestions(query);
          }, 140);
        });

        this.searchInput.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.moveSuggestionSelection(1);
            return;
          }

          if (event.key === 'ArrowUp') {
            event.preventDefault();
            this.moveSuggestionSelection(-1);
            return;
          }

          if (event.key === 'Escape') {
            this.hideSuggestions();
            return;
          }

          if (event.key === 'Enter') {
            event.preventDefault();

            if (this.suggestions.length > 0) {
              if (this.activeSuggestionIndex >= 0 && this.suggestions[this.activeSuggestionIndex]) {
                this.selectSuggestion(this.suggestions[this.activeSuggestionIndex]);
              } else {
                this.selectSuggestion(this.suggestions[0]);
              }
              return;
            }

            this.handleSearchSubmit();
          }
        });
      }

      if (this.csvInput) {
        this.csvInput.addEventListener('change', event => {
          const file = event.target.files && event.target.files[0];
          if (file) {
            this.processCsvFile(file);
          }
        });
      }

  

      this.root.addEventListener('click', event => {
        const actionEl = event.target.closest('[data-action]');
        if (!actionEl) return;

        const action = actionEl.dataset.action;

        switch (action) {
          case 'search':
            event.preventDefault();
            this.handleSearchSubmit();
            break;

          case 'clear-search':
            event.preventDefault();
            this.clearSearch();
            break;

          case 'clear-lines':
            event.preventDefault();
            this.clearQuickOrderState();
            this.showToast('Quick Order lines cleared.');
            break;

          case 'remove-line':
            event.preventDefault();
            this.removeLine(actionEl.dataset.lineKey);
            break;

          case 'qty-minus':
            event.preventDefault();
            this.adjustQuantity(actionEl.dataset.lineKey, -1);
            break;

          case 'qty-plus':
            event.preventDefault();
            this.adjustQuantity(actionEl.dataset.lineKey, 1);
            break;

          case 'add-to-cart':
            event.preventDefault();
            this.addSelectedToCart();
            break;

          default:
            break;
        }
      });

      this.root.addEventListener('change', event => {
        const qtyInput = event.target.closest('.quick-order__qty-input');
        if (!qtyInput) return;
        this.updateLineQuantityFromInput(qtyInput);
      });

      document.addEventListener('click', event => {
        if (!this.root.contains(event.target)) {
          this.hideSuggestions();
        }
      });
    }

    createToast() {
      const el = document.createElement('div');
      el.className = 'quick-order__toast hidden';
      document.body.appendChild(el);
      return el;
    }

    showToast(message) {
      if (!this.toastEl) return;

      this.toastEl.textContent = message;
      this.toastEl.classList.remove('hidden');

      requestAnimationFrame(() => {
        this.toastEl.classList.add('is-visible');
      });

      clearTimeout(this.toastTimeout);
      this.toastTimeout = setTimeout(() => {
        this.toastEl.classList.remove('is-visible');
        setTimeout(() => {
          this.toastEl.classList.add('hidden');
        }, 220);
      }, 3200);
    }

    clearQuickOrderState() {
      this.lines.clear();

      if (this.bulkTextarea) {
        this.bulkTextarea.value = '';
      }

      if (this.csvInput) {
        this.csvInput.value = '';
      }

      if (this.bulkReportEl) {
        this.bulkReportEl.innerHTML = '';
        this.bulkReportEl.classList.add('hidden');
      }

      this.setMessage('');
      this.hideSuggestions();
      this.clearSearch(false);
      this.render();
    }

    clearSearch(focus = true) {
      if (this.searchInput) {
        this.searchInput.value = '';
        if (focus) this.searchInput.focus();
      }
      this.hideSuggestions();
      this.activeSuggestionIndex = -1;
    }

    setLoading(isLoading) {
      if (!this.loadingEl) return;
      this.loadingEl.classList.toggle('hidden', !isLoading);
    }

    setMessage(message) {
      if (!this.messageEl) return;
      this.messageEl.textContent = message || '';
    }

    shopRoot() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
      return '/';
    }

    normalize(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');
    }

    escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    formatMoney(cents) {
      const amount = Number(cents || 0);

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        try {
          return window.Shopify.formatMoney(amount);
        } catch (error) {}
      }

      return `$${(amount / 100).toFixed(2)}`;
    }

    extractHandle(url) {
      if (!url) return '';
      const match = String(url).match(/\/products\/([^/?#]+)/i);
      return match ? match[1] : '';
    }

    extractVariantIdFromUrl(url) {
      if (!url) return null;

      try {
        const absolute = new URL(url, window.location.origin);
        return absolute.searchParams.get('variant');
      } catch (error) {
        const match = String(url).match(/[?&]variant=(\d+)/);
        return match ? match[1] : null;
      }
    }

    getColumnCount() {
      let count = 5;
      if (this.showSku) count += 1;
      if (this.showBarcode) count += 1;
      return count;
    }

    updateSummary() {
      if (!this.summaryEl) return;

      const lines = Array.from(this.lines.values());
      const lineCount = lines.length;
      const unitCount = lines.reduce((total, line) => total + Math.max(0, Number(line.quantity || 0)), 0);

      this.summaryEl.textContent = `${lineCount} line${lineCount === 1 ? '' : 's'} selected · ${unitCount} unit${unitCount === 1 ? '' : 's'}`;
    }

    render() {
      if (!this.resultsBody) return;

      const lines = Array.from(this.lines.values());

      if (!lines.length) {
        this.resultsBody.innerHTML = `
          <tr data-empty-row>
            <td colspan="${this.getColumnCount()}">
              Start typing a SKU, barcode, or title, upload a CSV, or use bulk paste to build the order.
            </td>
          </tr>
        `;
        this.updateSummary();
        return;
      }

      this.resultsBody.innerHTML = lines.map(line => this.renderRow(line)).join('');
      this.updateSummary();
    }

    renderRow(line) {
      const imageHtml =
        this.showImages && line.image
          ? `
            <div class="quick-order__item-image">
              <img src="${this.escapeHtml(line.image)}" alt="${this.escapeHtml(line.product_title)}">
            </div>
          `
          : '';

      const variantHtml =
        line.variant_title && line.variant_title !== 'Default Title'
          ? `<div class="quick-order__item-variant">${this.escapeHtml(line.variant_title)}</div>`
          : '';

      const messageHtml =
        line.row_message
          ? `<div class="quick-order__row-message quick-order__row-message--${this.escapeHtml(line.row_message_type || 'info')}">${this.escapeHtml(line.row_message)}</div>`
          : '';

      return `
        <tr data-line-id="${this.escapeHtml(line.key)}">
          <td>
            <div class="quick-order__item">
              ${imageHtml}
              <div class="quick-order__item-meta">
                <a class="quick-order__item-title" href="${this.escapeHtml(line.url || '#')}">
                  ${this.escapeHtml(line.product_title)}
                </a>
                ${variantHtml}
                ${messageHtml}
              </div>
            </div>
          </td>

          ${this.showSku ? `<td>${line.sku ? this.escapeHtml(line.sku) : '—'}</td>` : ''}
          ${this.showBarcode ? `<td>${line.barcode ? this.escapeHtml(line.barcode) : '—'}</td>` : ''}
          <td>${this.formatMoney(line.price)}</td>

          <td>
            <span class="quick-order__status ${line.available ? 'is-available' : 'is-unavailable'}">
              ${line.available ? 'Available' : 'Unavailable'}
            </span>
          </td>

          <td class="quick-order__qty-col">
            <div class="quick-order__qty-control">
              <button type="button" class="quick-order__qty-btn" data-action="qty-minus" data-line-key="${this.escapeHtml(line.key)}" aria-label="Decrease quantity">−</button>
              <input class="quick-order__qty-input" type="number" min="1" step="1" value="${Number(line.quantity) || 1}" data-line-key="${this.escapeHtml(line.key)}" aria-label="Quantity">
              <button type="button" class="quick-order__qty-btn" data-action="qty-plus" data-line-key="${this.escapeHtml(line.key)}" aria-label="Increase quantity">+</button>
            </div>
          </td>

          <td class="quick-order__action-col">
            <button type="button" class="quick-order__btn quick-order__btn--ghost quick-order__btn--small" data-action="remove-line" data-line-key="${this.escapeHtml(line.key)}">
              Remove
            </button>
          </td>
        </tr>
      `;
    }

    renderSuggestions() {
      if (!this.suggestionsEl) return;

      if (!this.suggestions.length) {
        this.hideSuggestions();
        return;
      }

      this.suggestionsEl.innerHTML = this.suggestions
        .map((item, index) => {
          const isActive = index === this.activeSuggestionIndex;
          const imageHtml =
            this.showImages && item.image
              ? `
                <div class="quick-order__suggestion-image">
                  <img src="${this.escapeHtml(item.image)}" alt="${this.escapeHtml(item.product_title)}">
                </div>
              `
              : '';

          const subtitle = item.variant_title && item.variant_title !== 'Default Title'
            ? item.variant_title
            : item.product_title;

          return `
            <button
              type="button"
              class="quick-order__suggestion ${isActive ? 'is-active' : ''}"
              data-suggestion-index="${index}"
              role="option"
              aria-selected="${isActive ? 'true' : 'false'}"
            >
              ${imageHtml}
              <div class="quick-order__suggestion-content">
                <div class="quick-order__suggestion-title">${this.escapeHtml(item.product_title)}</div>
                <div class="quick-order__suggestion-subtitle">${this.escapeHtml(subtitle)}</div>
                <div class="quick-order__suggestion-meta">
                  ${this.showSku && item.sku ? `<span>SKU: ${this.escapeHtml(item.sku)}</span>` : ''}
                  ${this.showBarcode && item.barcode ? `<span>Barcode: ${this.escapeHtml(item.barcode)}</span>` : ''}
                  <span>${this.formatMoney(item.price)}</span>
                  <span class="quick-order__suggestion-stock ${item.available ? 'is-available' : 'is-unavailable'}">
                    ${item.available ? 'Available' : 'Unavailable'}
                  </span>
                </div>
              </div>
            </button>
          `;
        })
        .join('');

      this.suggestionsEl.classList.remove('hidden');
      if (this.searchInput) {
        this.searchInput.setAttribute('aria-expanded', 'true');
      }

      this.suggestionsEl.querySelectorAll('[data-suggestion-index]').forEach(button => {
        button.addEventListener('click', () => {
          const index = Number(button.dataset.suggestionIndex);
          const suggestion = this.suggestions[index];
          if (suggestion) this.selectSuggestion(suggestion);
        });
      });
    }

    hideSuggestions() {
      if (!this.suggestionsEl) return;

      this.suggestionsEl.classList.add('hidden');
      this.suggestionsEl.innerHTML = '';
      this.suggestions = [];
      this.activeSuggestionIndex = -1;

      if (this.searchInput) {
        this.searchInput.setAttribute('aria-expanded', 'false');
      }
    }

    moveSuggestionSelection(direction) {
      if (!this.suggestions.length) return;

      this.activeSuggestionIndex += direction;

      if (this.activeSuggestionIndex < 0) {
        this.activeSuggestionIndex = this.suggestions.length - 1;
      }

      if (this.activeSuggestionIndex >= this.suggestions.length) {
        this.activeSuggestionIndex = 0;
      }

      this.renderSuggestions();
    }

    selectSuggestion(suggestion) {
      this.addOrIncrementLine(suggestion, 1, 'search');
      this.setMessage(`Added ${suggestion.product_title} to the order lines.`);
      this.clearSearch();
      this.render();
    }

    async handleSearchSubmit() {
      const query = this.searchInput ? this.searchInput.value.trim() : '';
      if (!query) {
        this.setMessage('Enter a SKU, barcode, or product title first.');
        return;
      }

      await this.searchAndAdd(query, 1);
    }

    async searchAndAdd(query, quantity = 1) {
      this.setLoading(true);
      this.setMessage('');

      try {
        const bestMatch = await this.findBestMatchingVariant(query);

        if (!bestMatch) {
          this.setMessage(`No matching product was found for "${query}".`);
          return;
        }

        this.addOrIncrementLine(bestMatch, quantity, 'search');
        this.setMessage(`Added ${bestMatch.product_title} to the order lines.`);
        this.clearSearch();
        this.render();
      } catch (error) {
        this.setMessage(error.message || 'Search failed.');
      } finally {
        this.setLoading(false);
      }
    }

    addOrIncrementLine(variant, quantity = 1, source = '') {
      const key = String(variant.id);

      if (this.lines.has(key)) {
        const existing = this.lines.get(key);
        existing.quantity = Math.max(1, Number(existing.quantity || 0) + Number(quantity || 1));
        existing.row_message = source === 'bulk' || source === 'csv' ? 'Quantity updated.' : '';
        existing.row_message_type = source === 'bulk' || source === 'csv' ? 'success' : 'info';
        this.lines.set(key, existing);
        return;
      }

      this.lines.set(key, {
        key,
        id: variant.id,
        product_title: variant.product_title,
        variant_title: variant.variant_title,
        sku: variant.sku,
        barcode: variant.barcode,
        price: variant.price,
        available: Boolean(variant.available),
        url: variant.url,
        image: variant.image,
        quantity: Math.max(1, Number(quantity || 1)),
        row_message: source === 'bulk' || source === 'csv' ? 'Added to order lines.' : '',
        row_message_type: source === 'bulk' || source === 'csv' ? 'success' : 'info'
      });
    }

    removeLine(key) {
      if (!key) return;
      this.lines.delete(String(key));
      this.render();
    }

    adjustQuantity(key, delta) {
      if (!key || !this.lines.has(String(key))) return;

      const line = this.lines.get(String(key));
      const nextQuantity = Math.max(1, Number(line.quantity || 1) + Number(delta || 0));
      line.quantity = nextQuantity;
      line.row_message = '';
      line.row_message_type = 'info';
      this.lines.set(String(key), line);
      this.render();
    }

    updateLineQuantityFromInput(input) {
      const key = input.dataset.lineKey;
      if (!key || !this.lines.has(String(key))) return;

      const parsed = parseInt(input.value, 10);
      const quantity = Number.isFinite(parsed) && parsed > 0 ? parsed : 1;

      const line = this.lines.get(String(key));
      line.quantity = quantity;
      line.row_message = '';
      line.row_message_type = 'info';
      this.lines.set(String(key), line);

      this.render();
    }

    async fetchPredictiveProducts(query) {
      const root = this.shopRoot();
      const url =
        `${root}search/suggest.json?q=${encodeURIComponent(query)}` +
        `&resources[type]=product` +
        `&resources[limit]=${encodeURIComponent(this.searchLimit)}` +
        `&resources[options][unavailable_products]=show` +
        `&resources[options][fields]=title,variants.sku,variants.barcode,variants.title`;

      const response = await fetch(url, {
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) {
        throw new Error('Predictive search failed.');
      }

      const data = await response.json();
      return (
        (data.resources &&
          data.resources.results &&
          Array.isArray(data.resources.results.products) &&
          data.resources.results.products) ||
        (data.resources && Array.isArray(data.resources.products) && data.resources.products) ||
        []
      );
    }

    async fetchProductByHandle(handle) {
      if (!handle) return null;

      if (this.productCache.has(handle)) {
        return this.productCache.get(handle);
      }

      const root = this.shopRoot();
      const url = `${root}products/${encodeURIComponent(handle)}.js`;

      const response = await fetch(url, {
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) {
        throw new Error(`Could not load product "${handle}".`);
      }

      const product = await response.json();
      this.productCache.set(handle, product);
      return product;
    }

    scoreVariantMatch(queryNorm, variant, productTitleNorm, predictiveVariantId = null) {
      const sku = this.normalize(variant.sku);
      const barcode = this.normalize(variant.barcode);
      const variantTitle = this.normalize(variant.public_title || variant.title);
      let score = 0;
      let matchType = 'title';

      if (sku && queryNorm === sku) {
        score += 500;
        matchType = 'sku';
      } else if (barcode && queryNorm === barcode) {
        score += 500;
        matchType = 'barcode';
      } else if (variantTitle && queryNorm === variantTitle) {
        score += 320;
        matchType = 'variant';
      } else if (productTitleNorm && queryNorm === productTitleNorm) {
        score += 260;
        matchType = 'title';
      } else {
        if (sku && sku.includes(queryNorm)) {
          score += 220;
          matchType = 'sku';
        }
        if (barcode && barcode.includes(queryNorm)) {
          score += 220;
          matchType = 'barcode';
        }
        if (variantTitle && variantTitle.includes(queryNorm)) {
          score += 160;
          if (matchType === 'title') matchType = 'variant';
        }
        if (productTitleNorm && productTitleNorm.includes(queryNorm)) {
          score += 120;
        }
      }

      if (predictiveVariantId && String(variant.id) === String(predictiveVariantId)) {
        score += 250;
      }

      if (variant.available) {
        score += 8;
      }

      return { score, matchType };
    }

    resolveBestVariant(query, product, predictiveProduct = null) {
      if (!product || !Array.isArray(product.variants) || !product.variants.length) {
        return null;
      }

      const queryNorm = this.normalize(query);
      const productTitleNorm = this.normalize(product.title);
      const predictiveVariantId = predictiveProduct ? this.extractVariantIdFromUrl(predictiveProduct.url) : null;

      let best = null;

      product.variants.forEach(variant => {
        const scored = this.scoreVariantMatch(queryNorm, variant, productTitleNorm, predictiveVariantId);

        if (!best || scored.score > best.score) {
          const variantImage =
            (variant.featured_image && variant.featured_image.src) ||
            (product.images && product.images[0]) ||
            product.featured_image ||
            '';

          best = {
            score: scored.score,
            match_type: scored.matchType,
            id: variant.id,
            product_title: product.title,
            variant_title: variant.public_title || variant.title || '',
            sku: variant.sku || '',
            barcode: variant.barcode || '',
            price: Number(variant.price || 0),
            available: Boolean(variant.available),
            image: variantImage,
            url: `${this.shopRoot()}products/${product.handle}?variant=${variant.id}`
          };
        }
      });

      return best && best.score > 0 ? best : null;
    }

    async findBestMatchingVariant(query) {
      const predictiveProducts = await this.fetchPredictiveProducts(query);
      if (!predictiveProducts.length) return null;

      const matches = await Promise.all(
        predictiveProducts.map(async predictiveProduct => {
          const handle = predictiveProduct.handle || this.extractHandle(predictiveProduct.url);
          if (!handle) return null;

          try {
            const product = await this.fetchProductByHandle(handle);
            return this.resolveBestVariant(query, product, predictiveProduct);
          } catch (error) {
            return null;
          }
        })
      );

      return matches.filter(Boolean).sort((a, b) => b.score - a.score)[0] || null;
    }

    async loadSuggestions(query) {
      const trimmed = String(query || '').trim();

      if (!trimmed || trimmed.length < 2) {
        this.hideSuggestions();
        return;
      }

      try {
        const predictiveProducts = await this.fetchPredictiveProducts(trimmed);

        if (!predictiveProducts.length) {
          this.hideSuggestions();
          return;
        }

        const suggestions = await Promise.all(
          predictiveProducts.map(async predictiveProduct => {
            const handle = predictiveProduct.handle || this.extractHandle(predictiveProduct.url);
            if (!handle) return null;

            try {
              const product = await this.fetchProductByHandle(handle);
              return this.resolveBestVariant(trimmed, product, predictiveProduct);
            } catch (error) {
              return null;
            }
          })
        );

        this.suggestions = suggestions.filter(Boolean).sort((a, b) => b.score - a.score).slice(0, this.searchLimit);
        this.activeSuggestionIndex = this.suggestions.length ? 0 : -1;
        this.renderSuggestions();
      } catch (error) {
        this.hideSuggestions();
      }
    }

    parseBulkLines(text) {
      return String(text || '')
        .split(/\r?\n/)
        .map(line => line.trim())
        .filter(Boolean)
        .map(line => {
          const match = line.match(/^(.*?)(?:[,\s;]+)(\d+)$/);
          if (match) {
            return {
              term: match[1].trim(),
              quantity: Math.max(1, parseInt(match[2], 10) || 1),
              original: line
            };
          }

          return {
            term: line,
            quantity: 1,
            original: line
          };
        });
    }

    async processBulkPaste() {
      const text = this.bulkTextarea ? this.bulkTextarea.value.trim() : '';

      if (!text) {
        this.setMessage('Paste at least one line first.');
        return;
      }

      if (this.bulkReportEl) {
        this.bulkReportEl.innerHTML = '';
        this.bulkReportEl.classList.add('hidden');
      }

      this.hideSuggestions();

      const entries = this.parseBulkLines(text);

      if (!entries.length) {
        this.setMessage('No valid lines were found.');
        return;
      }

      await this.processImportedEntries(entries, 'bulk');
    }

    readFileAsText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result || '');
        reader.onerror = () => reject(new Error('Could not read the CSV file.'));
        reader.readAsText(file);
      });
    }

    normalizeHeader(value) {
      return this.normalize(value).replace(/[^a-z0-9]/g, '');
    }

    parseCsvLine(line) {
      const result = [];
      let current = '';
      let inQuotes = false;

      for (let i = 0; i < line.length; i += 1) {
        const char = line[i];
        const next = line[i + 1];

        if (char === '"' && inQuotes && next === '"') {
          current += '"';
          i += 1;
          continue;
        }

        if (char === '"') {
          inQuotes = !inQuotes;
          continue;
        }

        if (char === ',' && !inQuotes) {
          result.push(current);
          current = '';
          continue;
        }

        current += char;
      }

      result.push(current);
      return result.map(value => value.trim());
    }

    detectCsvHeaderMap(firstRow) {
      const normalized = firstRow.map(value => this.normalizeHeader(value));
      const termIndex = normalized.findIndex(value =>
        ['sku', 'barcode', 'title', 'product', 'item', 'term', 'name'].includes(value)
      );
      const qtyIndex = normalized.findIndex(value =>
        ['quantity', 'qty', 'count', 'units'].includes(value)
      );

      const headerDetected = termIndex >= 0 || qtyIndex >= 0;

      return {
        headerDetected,
        termIndex: termIndex >= 0 ? termIndex : 0,
        qtyIndex: qtyIndex >= 0 ? qtyIndex : 1
      };
    }

    parseCsvText(text) {
      const rows = String(text || '')
        .split(/\r?\n/)
        .map(line => line.trim())
        .filter(Boolean)
        .map(line => this.parseCsvLine(line));

      if (!rows.length) return [];

      const headerMap = this.detectCsvHeaderMap(rows[0]);
      const dataRows = headerMap.headerDetected ? rows.slice(1) : rows;

      return dataRows
        .map(row => {
          const term = String(row[headerMap.termIndex] || '').trim();
          const rawQty = String(row[headerMap.qtyIndex] || '').trim();
          const quantity = Math.max(1, parseInt(rawQty, 10) || 1);

          if (!term) return null;

          return {
            term,
            quantity,
            original: row.join(', ')
          };
        })
        .filter(Boolean);
    }

    async processCsvFile(file) {
      this.setLoading(true);
      this.setMessage('');

      try {
        const text = await this.readFileAsText(file);
        const entries = this.parseCsvText(text);

        if (!entries.length) {
          this.setMessage('No usable rows were found in the CSV file.');
          return;
        }

        await this.processImportedEntries(entries, 'csv');
      } catch (error) {
        this.setMessage(error.message || 'CSV import failed.');
      } finally {
        this.setLoading(false);
      }
    }

    async processImportedEntries(entries, source = 'bulk') {
      if (!Array.isArray(entries) || !entries.length) {
        this.setMessage('No valid lines were found.');
        return;
      }

      this.setLoading(true);
      this.setMessage('');

      const matched = [];
      const unmatched = [];

      try {
        for (const entry of entries) {
          const term = String(entry.term || '').trim();
          const quantity = Math.max(1, parseInt(entry.quantity, 10) || 1);

          if (!term) continue;

          const bestMatch = await this.findBestMatchingVariant(term);

          if (!bestMatch) {
            unmatched.push({
              line: entry.original || term,
              detail: 'No product match found.'
            });
            continue;
          }

          this.addOrIncrementLine(bestMatch, quantity, source);

          matched.push({
            line: entry.original || term,
            detail: `${bestMatch.product_title} × ${quantity}`
          });
        }

        this.render();
        this.renderBulkReport({ matched, unmatched });

        if (matched.length && unmatched.length) {
          this.setMessage(`Imported ${matched.length} line(s). ${unmatched.length} line(s) need review.`);
        } else if (matched.length) {
          this.setMessage(`Imported ${matched.length} line(s) successfully.`);
        } else {
          this.setMessage('No lines were imported.');
        }
      } catch (error) {
        this.setMessage(error.message || 'Import failed.');
      } finally {
        this.setLoading(false);
      }
    }

    renderBulkReport(report) {
      if (!this.bulkReportEl) return;

      const matched = Array.isArray(report.matched) ? report.matched : [];
      const unmatched = Array.isArray(report.unmatched) ? report.unmatched : [];

      if (!matched.length && !unmatched.length) {
        this.bulkReportEl.innerHTML = '';
        this.bulkReportEl.classList.add('hidden');
        return;
      }

      const renderItems = (items, type) => {
        if (!items.length) {
          return `<li class="quick-order__report-item quick-order__report-item--empty">None</li>`;
        }

        return items
          .map(item => {
            const detailClass =
              type === 'error'
                ? 'quick-order__report-detail quick-order__report-detail--error'
                : 'quick-order__report-detail';

            return `
              <li class="quick-order__report-item">
                <div class="quick-order__report-line">${this.escapeHtml(item.line)}</div>
                <div class="${detailClass}">${this.escapeHtml(item.detail)}</div>
              </li>
            `;
          })
          .join('');
      };

      this.bulkReportEl.innerHTML = `
        <div class="quick-order__bulk-report-card">
          <div class="quick-order__bulk-report-header">
            <h3 class="quick-order__bulk-report-title">Import report</h3>
            <div class="quick-order__bulk-report-summary">
              <span class="quick-order__report-pill quick-order__report-pill--success">${matched.length} matched</span>
              <span class="quick-order__report-pill quick-order__report-pill--neutral">${unmatched.length} unmatched</span>
            </div>
          </div>

          <div class="quick-order__bulk-report-grid">
            <div class="quick-order__report-column">
              <h4 class="quick-order__report-heading">Matched</h4>
              <ul class="quick-order__report-list">${renderItems(matched, 'success')}</ul>
            </div>

            <div class="quick-order__report-column">
              <h4 class="quick-order__report-heading">Needs review</h4>
              <ul class="quick-order__report-list">${renderItems(unmatched, 'error')}</ul>
            </div>
          </div>
        </div>
      `;

      this.bulkReportEl.classList.remove('hidden');
    }

    async addSelectedToCart() {
      const rows = Array.from(this.lines.values());
      const eligible = rows.filter(line => Number(line.quantity) > 0 && line.available);

      if (!eligible.length) {
        this.setMessage('There are no available items to add to cart.');
        return;
      }

      this.setLoading(true);
      this.setMessage('');

      const items = eligible.map(line => ({
        id: line.id,
        quantity: Number(line.quantity)
      }));

      try {
        const response = await fetch(`${this.shopRoot()}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          let errorMessage = 'Could not add items to cart.';

          try {
            const errorData = await response.json();
            errorMessage = errorData.description || errorData.message || errorMessage;
          } catch (error) {}

          rows.forEach(line => {
            if (Number(line.quantity) > 0 && line.available) {
              line.row_message = errorMessage;
              line.row_message_type = 'error';
            }
          });

          this.render();
          throw new Error(errorMessage);
        }

        await response.json();

        const addedLines = eligible.length;
        const addedUnits = eligible.reduce((total, line) => total + Number(line.quantity || 0), 0);
        const skipped = rows.filter(line => !line.available || Number(line.quantity) <= 0).length;

        this.clearQuickOrderState();

        let toastMessage = `${addedLines} line${addedLines === 1 ? '' : 's'} added to cart · ${addedUnits} unit${addedUnits === 1 ? '' : 's'}.`;
        if (skipped > 0) {
          toastMessage += ` ${skipped} line${skipped === 1 ? '' : 's'} skipped.`;
        }

        this.showToast(toastMessage);
      } catch (error) {
        this.setMessage(error.message || 'Could not add items to cart.');
      } finally {
        this.setLoading(false);
      }
    }
  }
window.QuickOrder = QuickOrder;

  function initQuickOrder() {
    document.querySelectorAll('.quick-order').forEach(root => {
      if (!root.__quickOrderInstance) {
        root.__quickOrderInstance = new QuickOrder(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickOrder);
  } else {
    initQuickOrder();
  }
})();
